import React, { useState, useEffect } from "react";
import {
  ChevronLeftOutlined,
  ChevronRightOutlined,
  DesignServicesOutlined,
  ImageOutlined,
  OpenWithOutlined,
  Clear,
} from "@mui/icons-material";

export default function UIGallery({ figmaSrc, images }) {
  const [selected, setSelected] = useState(null);

  // Set default display
  useEffect(() => {
    if (figmaSrc) {
      setSelected("figma");
    } else if (images) {
      setSelected("gallery");
    }
  }, []);

  return (
    <>
      <div className="design-choice-btns">
        <button
          onClick={() => setSelected("figma")}
          className={`choice-btn 
                        ${!figmaSrc && "disabled"}
                        ${selected === "figma" && "selected"}
                    `}
          disabled={!figmaSrc}
        >
          <DesignServicesOutlined />
          {!figmaSrc ? <p>No Figma source</p> : <p>View Figma Wireframe</p>}
        </button>
        <button
          onClick={() => setSelected("gallery")}
          className={`choice-btn 
                        ${!images && "disabled"}
                        ${selected === "gallery" && "selected"}
                    `}
          disabled={!images}
        >
          <ImageOutlined />
          {!images ? <p>No gallery images</p> : <p>View UI Gallery</p>}
        </button>
      </div>

      {selected &&
        (selected === "figma" ? <FigmaFrame src={figmaSrc} /> : <Gallery images={images} />)}
    </>
  );
}

function FigmaFrame({ src }) {
  const [isEnlarged, setIsEnlarged] = useState(false);

  return (
    <>
      <div className="figma-container">
        <div className="figma-controls">
          <button onClick={() => setIsEnlarged(true)}>
            <OpenWithOutlined />
            <p>Enlarge</p>
          </button>
        </div>
        <iframe className="figma" src={src} />
      </div>

      {isEnlarged && (
        <Enlarged type={"figma"} defaultSrc={src} onClose={() => setIsEnlarged(false)} />
      )}
    </>
  );
}

function Gallery({ images }) {
  const [activeImage, setActiveImage] = useState(0);
  const [isEnlarged, setIsEnlarged] = useState(false);

  const toggleActiveImage = (dir) => {
    setActiveImage((curr) => {
      const newVal = curr + dir;

      if (newVal < 0) return images.length - 1;
      if (newVal > images.length - 1) return 0;

      return newVal;
    });
  };

  return (
    <>
      <div className="gallery">
        <div className="image-list">
          {images.map((img, i) => (
            <button
              key={i}
              onClick={() => setActiveImage(i)}
              className={`image-item ${i === activeImage && "active"}`}
              style={{
                background: `url('${img.src}')`,
                backgroundSize: "cover",
              }}
            />
          ))}
        </div>

        <div className="active-image">
          <div className="img-controls">
            <p>{images[activeImage].caption}</p>
            <button onClick={() => setIsEnlarged(true)}>
              <OpenWithOutlined />
              <p>Enlarge</p>
            </button>
          </div>

          <div className="img-chevron left">
            <button onClick={() => toggleActiveImage(-1)}>
              <ChevronLeftOutlined />
            </button>
          </div>
          <div className="img-chevron right">
            <button onClick={() => toggleActiveImage(1)}>
              <ChevronRightOutlined />
            </button>
          </div>

          <img src={images[activeImage].src} className="shown-image" />
        </div>
      </div>

      {isEnlarged && (
        <Enlarged
          type={"gallery"}
          imgPaths={images}
          defaultSrc={images[activeImage]}
          onClose={() => setIsEnlarged(false)}
        />
      )}
    </>
  );
}

export function Enlarged({ type, imgPaths, defaultSrc = null, onClose }) {
  const [activeImage, setActiveImage] = useState(defaultSrc);

  return (
    <div className="enlarged-bg">
      <div className="enlarged">
        <div className="enlarged-content">
          {type === "gallery" && (
            <div className="image-list">
              {imgPaths.map((i, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveImage(i)}
                  className={`image-item ${i === activeImage && "active"}`}
                  style={{
                    background: `url('${i.src}')`,
                    backgroundSize: "cover",
                  }}
                />
              ))}
            </div>
          )}
          <div className="enlarged-img">
            <div className="close-enlarged">
              <button onClick={() => onClose()}>
                <Clear />
              </button>
            </div>
            {type === "figma" ? (
              <iframe src={defaultSrc} className="enlarged-figma" />
            ) : (
              <img src={activeImage.src} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
